<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    headline: {
        type: String,
        required: true
    }
});

const searchPhrase = ref('');
const foundArticles = ref([]);
const searching = ref(null);
const total = ref(0);
const skip = ref(0);
const take = ref(50);

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);
    searchPhrase.value = urlParams.get('q') || '';
    searchArticles();
});

function searchArticles() {
    searching.value = true;

    if (searchPhrase.value.length === 0) {
        searching.value = false;
        return;
    }

    return fetch(`/umbraco/delivery/api/v2/content?filter=contentType:articlePage&skip=${skip.value}&take=${take.value}&sort=createDate:desc`)
        .then(response => response.json())
        .then(data => {
            total.value = data.total;

            foundArticles.value = foundArticles.value.concat(data.items.filter(article => (
                article.name.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.navigationName?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.navigationTitle?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.seoTitle?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.seoDescription?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.someTitle?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.someDescription?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.articleSettingsHeadline?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.articleSettingsTeaserText?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.articleSettingsGenreTag?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.articleSettingsJournalist?.name?.toLowerCase().includes(searchPhrase.value.toLowerCase()) ||
                article.properties.moduleItems?.items?.filter(x =>
                    (x.content.contentType == 'text' || x.content.contentType == 'bulletList') &&
                    x.content.properties.richText?.markup.toLowerCase().includes(searchPhrase.value.toLowerCase())
                ).length > 0
            )));

            skip.value += take.value;

            if (total.value > skip.value) {
                searchArticles();
            }
        });
}

function getImagePath(image) {
    if (!image) {
        return '';
    }

    return `${image.url}?rxy=${image.focalPoint?.top},${image.focalPoint?.left}&width=150&height=150&quality=90`;
}

function getDisplayDate(date) {
    return `${new Date(date).getDate()}/${new Date(date).getMonth() + 1} ${new Date(date).getFullYear()}`;
}
</script>
<template>
    <article class="search-result module module--white h--pad--wide">
        <h1>{{ props.headline }} i din søgning efter '{{ searchPhrase }}'</h1>
        <form class="search-result__form" method="GET">
            <input name="q" :value="searchPhrase" />
            <button>Søg</button>
        </form>
        <ul class="search-result__list">
            <li v-for="article in foundArticles" :key="article.id" class="search-result__item">
                <img v-if="article.properties.articleSettingsMainImage?.length > 0" class="search-result__image" :src="getImagePath(article.properties.articleSettingsMainImage[0])" alt="" />
                <div>
                    <p>
                        {{ getDisplayDate(article.properties.articleSettingsDate) }}:
                        <br />
                        {{ article.properties.articleSettingsHeadline }}
                    </p>
                    <p>{{ article.properties.articleSettingsTeaserText }}</p>
                    <p><a class="search-result__link" :href="article.route.path">Læs artiklen</a></p>
                </div>
            </li>
        </ul>
    </article>
</template>
<style lang="scss" scoped>
    .search-result {

        &__form {
            width: 400px;
            max-width: 100%;
            position: relative;
            display: inline-flex;

            input {
                width: 100%;
                height: 48px;
                padding-left: 20px;
                padding-right: 20px;
                margin-bottom: 48px;
                border: 1px solid #222;
                font-family: inherit;

                @media (min-width: 1024px) {
                    height: 60px;
                }
            }

            button {
                height: 40px;
                background-color: #fd605b;
                padding-left: 20px;
                padding-right: 20px;
                border-width: 0;
                position: absolute;
                top: 4px;
                right: 4px;
                font-family: inherit;
                font-weight: 700;
                color: #fff;

                @media (min-width: 1024px) {
                    height: 44px;
                    top: 8px;
                    right: 8px;
                }
            }
        }

        &__list {
            list-style-type: none;
            margin: 0;
            padding: 0;
            display: grid;
            grid-template-columns: 1fr;
            gap: 48px;
        }

        &__item {
            display: grid;
            grid-template-columns: auto 1fr;
            gap: 24px;
        }

        &__image {
            width: 150px;
            height: 150px;
        }
    }
</style>
